<template>
  <!--
    The customer testimonial carousel. Lived inline on the Pricing page until
    Steve asked for the same carousel on Customer Stories and Watch Demo
    (18 Sep 2026), so it is one component now. Cards are data (`items`):
    a quote with a headline, and either a logo or a text attribution.
    Card and title styles are global (custom.scss .testimonial-*).
  -->
  <section class="testimonial-carousel">
    <v-row no-gutters>
      <v-col cols="12" align-self="center">
        <v-container>
          <div class="testimonial-title text-center">
            <img
              src="/static/homepage/testimonial/improve-customer-testimonials.png"
              alt=""
            />
            <h2>{{ title }}</h2>
            <p>{{ lead }}</p>
          </div>
        </v-container>
      </v-col>
    </v-row>
    <v-container>
      <VueSlickCarousel v-bind="settings">
        <div v-for="item in items" :key="item.headline" class="testimonial-item">
          <div class="testimonial-card">
            <div>
              <h2>“{{ item.headline }}”</h2>
              <p>“{{ item.quote }}”</p>
            </div>
            <img v-if="item.logo" :src="item.logo" :alt="item.logoAlt || item.company" />
            <p v-else class="testimonial-attrib">
              <strong>{{ item.attribution }}</strong><br />
              {{ item.role }}
            </p>
          </div>
        </div>
      </VueSlickCarousel>
    </v-container>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import { CAROUSEL_TESTIMONIALS } from '@/data/testimonials';

export default {
  name: 'TestimonialCarousel',
  components: { VueSlickCarousel },
  props: {
    title: { type: String, default: 'Customer Testimonials' },
    lead: { type: String, default: 'What our customers say about IMPROVE' },
    items: { type: Array, default: () => CAROUSEL_TESTIMONIALS },
  },
  data() {
    return {
      settings: {
        infinite: true,
        autoplay: true,
        dots: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 959, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      },
    };
  },
};
</script>

<style scoped>
.testimonial-carousel {
  margin-bottom: 40px;
}

.testimonial-attrib {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #6b7280;
}

.testimonial-attrib strong {
  color: #002458;
}
</style>
